// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__jlDaP","Content":"Layout_Content__KZC47"};